import React from "react";
import { Button, Input } from "reactstrap";

const SceneTable = ({
  scenes,
  editingScene,
  editPrompt,
  setEditPrompt,
  editingVideoPrompt,
  editVideoPrompt,
  setEditVideoPrompt,
  regeneratingScene,
  onEditPrompt,
  onSavePrompt,
  onCancelEdit,
  onEditVideoPrompt,
  onSaveVideoPrompt,
  onCancelVideoEdit,
  onRegenerateImage
}) => {
  return (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th width="10%">Scene</th>
            <th width="25%">Image</th>
            <th width="40%">Description</th>
            <th width="15%">Video Prompt</th>
            <th width="10%">Actions</th>
          </tr>
        </thead>
        <tbody>
          {scenes.map((scene, index) => (
            <tr key={scene.scene_number}>
              <td className="align-middle text-center">
                <strong>Scene {scene.scene_number}</strong>
              </td>
              <td className="text-center">
                {scene.imageUrl ? (
                  <img
                    src={scene.imageUrl}
                    alt={`Scene ${scene.scene_number}`}
                    className="img-fluid rounded"
                    style={{
                      height: "120px",
                      width: "120px",
                      objectFit: "cover",
                    }}
                  />
                ) : scene.isGeneratingImage ? (
                  <div
                    className="bg-light d-flex align-items-center justify-content-center rounded"
                    style={{
                      height: "120px",
                      width: "120px",
                      margin: "0 auto",
                    }}
                  >
                    <div className="text-center">
                      <i className="fa fa-spinner fa-spin fa-2x text-primary mb-2"></i>
                      <br />
                      <small className="text-muted">Generating...</small>
                    </div>
                  </div>
                ) : (
                  <div
                    className="bg-light d-flex align-items-center justify-content-center rounded"
                    style={{
                      height: "120px",
                      width: "120px",
                      margin: "0 auto",
                    }}
                  >
                    {scene.error ? (
                      <small className="text-danger text-center">Failed</small>
                    ) : (
                      <small className="text-muted text-center">Waiting...</small>
                    )}
                  </div>
                )}
              </td>
              <td className="align-middle">
                {editingScene === index ? (
                  <div>
                    <Input
                      type="textarea"
                      value={editPrompt}
                      onChange={(e) => setEditPrompt(e.target.value)}
                      rows={3}
                      className="mb-2"
                    />
                    <div className="d-flex gap-1">
                      <Button
                        color="success"
                        size="sm"
                        onClick={() => onSavePrompt(index)}
                      >
                        <i className="fa fa-check"></i>
                      </Button>
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={onCancelEdit}
                      >
                        <i className="fa fa-times"></i>
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <p className="mb-0 small">{scene.description}</p>
                    <Button
                      color="link"
                      size="sm"
                      className="p-0 mt-1"
                      onClick={() => onEditPrompt(index)}
                    >
                      <i className="fa fa-edit me-1"></i>
                      Edit
                    </Button>
                  </div>
                )}
                {scene.isGeneratingImage && (
                  <div className="mt-1">
                    <span className="badge bg-primary">
                      <i className="fa fa-spinner fa-spin me-1"></i>
                      Generating Image
                    </span>
                  </div>
                )}
              </td>
              <td className="align-middle">
                {editingVideoPrompt === index ? (
                  <div>
                    <Input
                      type="textarea"
                      value={editVideoPrompt}
                      onChange={(e) => setEditVideoPrompt(e.target.value)}
                      rows={2}
                      className="mb-2"
                    />
                    <div className="d-flex gap-1">
                      <Button
                        color="success"
                        size="sm"
                        onClick={() => onSaveVideoPrompt(index)}
                      >
                        <i className="fa fa-check"></i>
                      </Button>
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={onCancelVideoEdit}
                      >
                        <i className="fa fa-times"></i>
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div>
                    {scene.video_prompt && (
                      <p className="mb-0 small text-muted">{scene.video_prompt}</p>
                    )}
                    <Button
                      color="link"
                      size="sm"
                      className="p-0 mt-1"
                      onClick={() => onEditVideoPrompt(index)}
                    >
                      <i className="fa fa-edit me-1"></i>
                      Edit
                    </Button>
                  </div>
                )}
              </td>
              <td className="align-middle text-center">
                <Button
                  color="info"
                  size="sm"
                  onClick={() => onRegenerateImage(index)}
                  disabled={regeneratingScene === index}
                >
                  {regeneratingScene === index ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : (
                    <i className="fa fa-refresh"></i>
                  )}
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SceneTable;